import { render } from "./CCarousel.vue?vue&type=template&id=7a4ec4f2"
import script from "./CCarousel.vue?vue&type=script&lang=js"
export * from "./CCarousel.vue?vue&type=script&lang=js"

import "./CCarousel.vue?vue&type=style&index=0&id=7a4ec4f2&lang=scss"

import exportComponent from "/Users/matteomelillo/Dev/wpHeadless/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__